import { getRowId } from './getRowId';

// Select-all is stored as "everything except these ids", so a checkbox click
// only ever rewrites the ids inside the loaded window — ids a sort pushed out
// of it must survive, or those rows silently become selected again.
export const resolveDeselectedRowIds = (
  previousDeselectedRowIds: Set<string>,
  selectionValue: any[],
  data: any[],
  dataKey: string,
  isSelectAllMode: boolean
): Set<string> => {
  if (!isSelectAllMode) {
    return previousDeselectedRowIds.size === 0
      ? previousDeselectedRowIds
      : new Set<string>();
  }

  const loadedIds = new Set<string>();
  data.forEach((row) => {
    const id = getRowId(row, dataKey);
    if (id !== null) loadedIds.add(id);
  });

  const selectedIds = new Set<string>();
  selectionValue.forEach((row) => {
    const id = getRowId(row, dataKey);
    if (id !== null) selectedIds.add(id);
  });

  const nextDeselectedRowIds = new Set<string>();
  previousDeselectedRowIds.forEach((id) => {
    if (!loadedIds.has(id)) nextDeselectedRowIds.add(id);
  });
  loadedIds.forEach((id) => {
    if (!selectedIds.has(id)) nextDeselectedRowIds.add(id);
  });

  return nextDeselectedRowIds;
};
